import { GlobalData } from "../Common/GlobalData";
import { TemplateHelpers, BigPictureHelper } from "../Common/KendoHelpers";
import { MarketSmithHelper } from "../Common/MarketSmithHelper";
import { StockPickList } from "../Common/StockPickList";

export class ChecklistSummary {
    private static readonly GRID = '#grid';

    constructor(index: number) {
        this.init(index);
    }

    private init(index: number) {
        const stockPickList = new StockPickList(ChecklistSummary.GRID,
            GlobalData.URL_SUFFIX_GENERAL_REPORTS_CHECKLIST_SUMMARY, index);

        this.initBigPictureHeader();

        $(ChecklistSummary.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            resizable: true,
            dataBound: () => {
                var marketSmithHelper = new MarketSmithHelper();
                marketSmithHelper.dataBoundInit(3, 4, 5, 10);
            },
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '19%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'close',
                title: 'Close',
                width: '6%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'compositeRating',
                title: 'MARKET<br>Comp Rating',
                width: '7%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'earningsPerShareRating',
                title: 'FUNDAMENTAL<br>EPS Rating',
                width: '9%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'relativeStrengthRating',
                title: 'TECHNICAL<br>RS Rating',
                width: '7%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'relativeStrengthLineNewHigh',
                title: 'RS Line<br>New High',
                width: '6%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getGreenBoolTemplate('relativeStrengthLineNewHigh')),
            }, {
                field: 'numBlueDots',
                title: 'Number<br>Blue Dots',
                width: '6%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'earningsStability',
                title: 'Earnings<br>Stability',
                width: '6%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'fullCurrentPctK',
                title: 'STO<br>%K',
                width: '4%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'pivotNote1',
                title: 'PivotNote1',
                width: '17%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'earningsPerShareDueDate',
                title: 'Earnings<br>Due Date',
                width: '7%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('earningsPerShareDueDate')),
            }]
        });
    }

    private initBigPictureHeader() {
        BigPictureHelper.showBigPictureData();
    }
}
